import { render, staticRenderFns } from "./bulkTranslationImport.vue?vue&type=template&id=b051b8d4"
import script from "./bulkTranslationImport.vue?vue&type=script&lang=js"
export * from "./bulkTranslationImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports